import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DateUtils } from '@vectord/utils';

import {
  rescheduleClassesFormAcademyScheduleSelector,
  rescheduleClassesFormStartDateSelector,
  rescheduleClassesFormSetStartDate,
} from 'features/classCreation';
import { useGetHolidayListQuery } from 'services/holidayService';
import DateInput from 'components/DateInput';
import getDatesForSchedule from 'utils/getDatesForSchedule';
import styles from './NewScheduleStartDateInput.module.scss';

function NewScheduleStartDateInput() {
  const { data } = useGetHolidayListQuery();
  const holidays = data?.data;
  const dispatch = useDispatch();
  const startDate = useSelector(rescheduleClassesFormStartDateSelector);
  const academySchedule = useSelector(
    rescheduleClassesFormAcademyScheduleSelector
  );

  // Allow schedule till max next 6 months
  const minDate = useMemo(() => new Date(), []);
  const maxDate = useMemo(
    () => new Date(Date.now() + 180 * DateUtils.ONE_DAY),
    []
  );

  const allowedDates = useMemo(() => {
    if (!academySchedule) return [];

    return getDatesForSchedule({
      holidays,
      dayTimes: academySchedule.dayTimes,
      start: minDate,
      end: maxDate,
    });
  }, [academySchedule, holidays, maxDate, minDate]);

  const handleChange = useCallback(
    (value) => {
      dispatch(rescheduleClassesFormSetStartDate(value));
    },
    [dispatch]
  );

  const checkIfDateDisabled = useCallback(
    (currentDate) => {
      return allowedDates.every(
        (allowedDate) => !DateUtils.isSameDay(allowedDate, currentDate)
      );
    },
    [allowedDates]
  );

  if (academySchedule) {
    return (
      <DateInput
        className={styles.root}
        disabled={checkIfDateDisabled}
        fromDate={minDate}
        onChange={handleChange}
        placement="top"
        toDate={maxDate}
        value={startDate}
      />
    );
  } else {
    return null;
  }
}

export default NewScheduleStartDateInput;
